import {
  Button, Fade, HStack, Menu, MenuButton, MenuItem, MenuList, Portal, Text, Tooltip,
} from "@chakra-ui/react";
import ModalFormWrapper from "components/ModalForm/ModalFormWrapper";
import { FiPlus } from "react-icons/fi";
import SimpleEmployeeForm from "components/Forms/SimpleEmployeeForm";
import NewHireForm from ".";

export default function AddNewHireOrExistingEmployeeButton({ isExpanded }: { isExpanded: boolean }) {
  return (
    <Menu>
      <Tooltip label="Add Employee" isDisabled={isExpanded} placement="right">
        <MenuButton
          as={Button}
          size="sm"
          px={isExpanded ? 4 : 2}
          justifyContent={isExpanded ? "start" : "center"}
          leftIcon={<FiPlus />}
          iconSpacing={isExpanded ? 2 : 0}
        >
          <HStack spacing="2" align="center">
            <Fade in={isExpanded} unmountOnExit>
              <Text>Add Employee</Text>
            </Fade>
          </HStack>
        </MenuButton>
      </Tooltip>
      <Portal>
        <MenuList>
          <ModalFormWrapper
            modalHeader="Add New Hire"
            button={<MenuItem>Add New Hire</MenuItem>}
            size="md"
          >
            <NewHireForm />
          </ModalFormWrapper>
          <ModalFormWrapper modalHeader="Add Existing Employee" button={<MenuItem>Add Existing Employee</MenuItem>}>
            <SimpleEmployeeForm />
          </ModalFormWrapper>
        </MenuList>
      </Portal>
    </Menu>
  );
}
